export default __webpack_public_path__ + "static/media/Indenfor10minutter-Copenhagenlightfestival_aflangt.dcd8d0e8.png";